import "isomorphic-fetch"
import {environment as env} from '../../environments/environment';

export interface Options {
    method: string;
    headers?: object
    body?: string;
}

class httpHandler {
    wp(url: string, data: any) {
        let formData = this.json2form(data);
        return fetch(url,
            {
                body: formData,
                method: "post"
            }).then((response) => {
            return response.json()
        })
            .then((data) => {
                if (data && (data.statusCode === 200 || data.status === 'ok')) {
                    return data;
                } else if (data.error) {
                    throw data.error;
                } else {
                    return data;
                }
            });
    }

    ajx(url: string, data: any) {
        let dataString = 'ajax=' + url;

        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataString += '&' + key + '=' + data[key];
            }
        }

        const options: RequestInit = {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: dataString,
        };
        return fetch(env.themeRoot + 'ajx/dispatch.php', options)
            .then((response) => {
                return response.json()
            })
    }

    post(url: string, data: any, headers: HeadersInit = null): Promise<object> {
        const options: RequestInit = {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(data),
        };

        if (headers) {
            options.headers = headers;
        } else {
            options.headers = {
                'content-type': 'application/json'
            }
        }

        return fetch(url, options)
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                if (data && (data.statusCode === 200 || data.status === 'ok')) {
                    return data;
                } else if (data.error) {
                    throw data.error;
                } else {
                    return data;
                }
            })
    }

    // todo: handle nested params/data > object, array & etc.
    async post2(url: string, data?: any) {

        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Accept': 'application/json, text/javascript, */*; q=0.01',
                // 'Content-Type': 'application/json; charset=utf-8',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'same-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: (new URLSearchParams(data)).toString() // body data type must match "Content-Type" header
        }).catch(err => {
            console.error(err);
        }) as Response;

        return response?.json(); // parses JSON response into native JavaScript objects
    }

    get(url: string) {
        return fetch(url)
            .then((response) => response.json())
            .then((data) => {
                // console.log('Get Success:', data);
                return data;
            })
            .catch((error) => {
                console.error('Get Error:', error);
                return error;
            });
    }


    private buildFormData(formData: FormData, data: any, parentKey?: any) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        } else {
            const value = data == null ? '' : data;

            formData.append(parentKey, value);
        }
    }

    private json2form(data: any): FormData {
        const formData = new FormData();

        this.buildFormData(formData, data);

        return formData;
    }
}

export const http = new httpHandler();


